export default __webpack_public_path__ + "static/media/refer-right.9e75d414.svg";